module.exports = __webpack_public_path__ + "img/sushitortefrontal.efb7a643.png";